import { filterOptions } from '@/utils/query-base'
import { formatSapDate } from '@/mixins/index'
const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])
export default {
  'partner': {
    title: '客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    },
    slot: true
  },
  'name_last': {
    title: '客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'zzfld000016': {
    describe: true,
    title: '客户类型',
    type: 'select',
    equation: city,
    dictionary: 'A0009'//
  },
  'zzcustchal': {
    describe: true,
    title: '渠道类型',
    type: 'select',
    equation: all,
    dictionary: 'A0054'//
  },
  'zzfld000017': {
    title: '旧编码',
    type: 'input',
    equation: all
  },
  'mc_short': {
    title: '营销单元'
  },
  'zzfld00003e': {
    describe: true,
    title: '基地',
    type: 'select',
    equation: all,
    dictionary: 'base'
  },
  'flag_dgd': {
    title: '待归档标识',
    type: 'whether',
    equation: all,
    slot: true
  },
  'zzfld000026': {
    title: '归档标识',
    type: 'whether',
    equation: all,
    slot: true
  },
  'zzfld00009n': {
    title: '已停止未归档',
    type: 'whether',
    equation: all,
    slot: true
  },
  'zzfld000026_date': {
    title: '归档日期',
    type: 'date'
  },
  // 'channelmanager': {
  //   title: '渠道经理',
  //   type: 'input',
  //   equation: all
  // },
  'zzfld000018': {
    title: '法人姓名',
    type: 'input',
    equation: all
  },
  'zzfld000019': {
    title: '法人电话',
    type: 'input',
    equation: all
  },
  'zzfld00001a': {
    title: '统一社会信用代码',
    type: 'input',
    equation: all,
    width: 200
  },
  'zzfld00001b': {
    title: '工商登记号',
    type: 'input',
    equation: all
  },
  // 'deliverycode': {
  //   title: '运达方编码',
  //   type: 'dialog',
  //   equation: all,
  //   dialog: {
  //     component: 'ClientSelect',
  //     title: '运达方编码'
  //   }
  // },
  'partner_yg': {
    title: '客户负责员工',
    type: 'input',
    equation: all
  },
  'name_yg': {
    title: '客户负责员工名称',
    type: 'input',
    equation: all,
    width: 150
  },
  // 'linkman': {
  //   title: '收货人联系人',
  //   type: 'input',
  //   equation: all
  // },
  // 'zzfld00001c': {
  //   title: '营销管理编码',
  //   type: 'input',
  //   equation: all
  // },
  'zzfld00001d': {
    title: '变更自客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户选择'
    }
  },
  'zzfld00001d_name': {
    title: '变更自客户名称',
    type: 'input',
    equation: all,
    width: 250
  },
  'partner_kp': {
    title: '开票客户编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '开票客户编码'
    }
  },
  'namelast_kp': {
    title: '开票客户描述',
    type: 'input',
    equation: all,
    width: 200
  },
  'region': {
    describe: true,
    title: '省份',
    type: 'select',
    equation: be,
    dictionary: 'region'
  },
  'city_code': {
    describe: true,
    title: '城市',
    type: 'select',
    equation: city,
    dictionary: 'city'
  },
  'street_code': {
    describe: true,
    title: '区',
    type: 'select',
    equation: city,
    dictionary: 'street'
  },
  'datum': {
    title: '创建日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'zzfld00003d': {
    title: '历史创建日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'remark_gd': {
    title: '归档备注',
    type: 'input',
    equation: all
  },
  'remark_blk': {
    title: '停用备注',
    type: 'input',
    equation: all
  },
  'zzxy': {
    title: '终止协议',
    type: 'whether'
  },
  'zzfld00008r': {
    title: '备注',
    type: 'input',
    equation: all,
    width: 200
  },
  'zzfld00008s': {
    title: '备注1',
    type: 'input',
    width: 200
  }
}



// WEBPACK FOOTER //
// ./src/views/client-manage/config/maintenanceList.js